import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTeamCollabs, setTeamsCollabs } from "../../components/clients/clientsSlice";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Langs from "../../app/lang/langs";
import addIcon from '../../assets/images/add.png'
import addIconFocus from '../../assets/images/addFocus.png'
import ImageButton from "../../components/buttons/ImageButton";
import AddTeamsMembersModal from "./AddTeamsMembersModal";
import { addTeam, getTeams, getTeamsManagers, setTeamManagers } from "../../components/teams/teamsSlice";
import { Col, Row } from "react-bootstrap";
import { NumberInput } from "../../components/inputs/NumberInput";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { faNotEqual } from "@fortawesome/free-solid-svg-icons";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import { showErrorToast } from "../../app/utils/helpers";
import { getSettings } from "../settings/settingsSlice";
import { getClients } from "../ventr/VentrSlice";

export default function AddTeamModal(props) {
    const dispatch = useDispatch()

    const hoursSettings = useSelector((state) => state.settings.settingsList)

    const [name, setName] = useState('');
    const [sousService, setSousService] = useState('');
    const [localization, setLocalization] = useState('')
    const [lunchBreakDuration, setLunchBreakDuration] = useState(0);
    const [fraisTransport, setFraisTransport] = useState(0);
    const [forfaitDeplacement, setFofaitDeplacement] = useState(0);
    const [attempt, setAttempt] = useState(false);
    const [idTeamDB, setIdTeamDB] = useState(null);
    const [client, setClient] = useState(null);
    const [clientOptions, setClientOptions] = useState([]);
    const clients = useSelector((state) => state.clients.list);

    useEffect(() => {console.log(client)}, [client])


    useEffect(() => {
        if (props.visible) {
            dispatch(getSettings());
            dispatch(getClients())
        }
    }, [props.visible])

    useEffect(() => {
        if (clients && clients.length > 0) {
            const options = clients.map(client => ({ label: client.label, id: client.id }));
            setClientOptions(options);
        }
    }, [clients]);

    useEffect(()=>{console.log("client: ",client)},[client])

    const locations = [
        'INSITU',
        'MERIGNAC',
        'LGC',
        'GARDIGNAN',
        'NEUILLY',
        'INCONNU',
        'BEYROUTH',
        'ILE MAURICE'
    ]
    const orderOfSettings = [
        "Heure début de journée",
        "Heure mi-journée",
        "Heure fin de journée",
        "Heure début nuit",
        "Heure fin nuit"
    ];

    const handleClose = () => {
        props.setVisible(false);
        setName('');
        setSousService('')
        setLocalization('')
        setLunchBreakDuration(0);
        setFraisTransport(0);
        setFofaitDeplacement(0);
        setIdTeamDB(null)
        setClient(null)
        setAttempt(false);
    }
    const handleAddTeam = () => {
        if (client) {
            if (name.trim() !== '') {
                dispatch(
                    addTeam(
                        {
                            id_client: client.id,
                            name: name,
                            sous_service: sousService,
                            localization: localization,
                            lunch_break_duration: lunchBreakDuration,
                            frais_transport: fraisTransport,
                            forfait_deplacement: forfaitDeplacement
                        }
                    )
                ).then((actionResponse) => {
                    if (addTeam.fulfilled.match(actionResponse)) {
                        dispatch(getTeams())
                        handleClose()
                    } else {
                        showErrorToast('Something went wrong')
                    }
                }).catch((error) => {
                    console.log(error)
                    showErrorToast('Something went wrong')
                });
                handleClose()
            } else {
                setAttempt(true)
            }
        } else {
            showErrorToast('Veuillez sélectionner un client')
        }
    }

    const header = () => {
        return (<p><Langs str='ADD_TEAM' /> <b></b></p>)
    }

    const body = () => {
        return (
            <div>
                <Row className="my-3">
                    <Col lg={6}>
                        <Langs str="CLIENT" />
                    </Col>
                    <Col lg={6}>
                        <Dropdown value={client} filter onChange={(e) => setClient(e.value)} options={clientOptions} optionLabel="label"
                            placeholder="client" style={{ width: '100%', borderRadius: '50px' }} checkmark={true} highlightOnSelect={false} />
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col lg={6}>
                        <Langs str='TEAM_NAME' />
                    </Col>
                    <Col lg={6}>
                        <InputText invalid={name.trim() === '' && attempt} style={{ width: '100%', borderRadius: '50px' }} value={name} onChange={(e) => setName(e.target.value)} />
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col lg={6}>
                        Sous Service
                    </Col>
                    <Col lg={6}>
                        <InputText style={{ width: '100%', borderRadius: '50px' }} value={sousService} onChange={(e) => setSousService(e.target.value)} />
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col lg={6}>
                        <Langs str="localization" />
                    </Col>
                    <Col lg={6}>
                        <Dropdown value={localization} onChange={(e) => setLocalization(e.value)} options={locations} optionLabel="name"
                            placeholder="localization" style={{ width: '100%', borderRadius: '50px' }} checkmark={true} highlightOnSelect={false} />
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col lg={6}>
                        <Langs str="LUNCH_BREAK_DURATION" />
                    </Col>
                    <Col lg={6}>
                        <NumberInput
                            id={`LUNCH-BREAK-DURATION-IN`}
                            value={lunchBreakDuration}
                            min={0}
                            max={24}
                            onChange={(e) => setLunchBreakDuration(e.target.value || 0)}
                        />
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col lg={6}>
                        <Langs str="FORFAIT_DEPLACEMENT" />
                    </Col>
                    <Col lg={6}>
                        <NumberInput
                            id={`FORFAIT-DEPLACEMENT-IN`}
                            value={forfaitDeplacement}
                            min={0}
                            onChange={(e) => setFofaitDeplacement(e.target.value || 0)}
                        />
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col lg={6}>
                        <Langs str="FRAIS_TRANSPORT" />
                    </Col>
                    <Col lg={6}>
                        <NumberInput
                            id={`FRAIS-TRANSPORT-IN`}
                            value={fraisTransport}
                            min={0}
                            onChange={(e) => setFraisTransport(e.target.value || 0)}
                        />
                    </Col>
                </Row>
            </div>
        )
    }
    function footer() {
        return (
            <Row className="d-flex justify-content-center">
                <Col lg={3} xs={3}>
                    <DynamicButton
                        onClick={() => handleAddTeam()}
                        className='me-auto'
                        title={<Langs str="ADD" />}
                        active={true}
                        color="green"
                    />
                </Col>
            </Row>
        )
    }

    return (
        <Dialog
            visible={props.visible}
            style={{ width: '50rem' }}
            onHide={() => { if (!props.visible) return; handleClose() }}
            position="center"
            draggable={false}
            header={header}
            footer={footer}
        >
            {body()}
        </Dialog>
    )
}